import { render } from "./RecommendedSection.vue?vue&type=template&id=497e072a"
import script from "./RecommendedSection.vue?vue&type=script&lang=js"
export * from "./RecommendedSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__